import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DirectoryItem } from '../../_models/directory.model';

@Injectable({ providedIn: 'root' })
export class SupplierModalService {
  private openSubject = new Subject<DirectoryItem | null>();
  private registeredSubject = new Subject<void>();
  open$ = this.openSubject.asObservable();
  /** Se emite solo cuando se registró un socio, no al cerrar el modal. */
  registered$ = this.registeredSubject.asObservable();

  /** Abre el modal de Nuevo Proveedor, pre-poblado si viene desde el directorio. */
  open(data: DirectoryItem | null = null): void {
    this.openSubject.next(data);
  }

  notifyRegistered(): void {
    this.registeredSubject.next();
  }
}
